export const FETCH_ALLDRIVER_REQUEST = 'FETCH_ALLDRIVER_REQUEST'
export const FETCH_ALLDRIVER_SUCCESS = 'FETCH_ALLDRIVER_SUCCESS'
export const FETCH_ALLDRIVER_FALIURE = 'FETCH_ALLDRIVER_FALIURE'
